import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";
import { useLocation } from "react-router-dom";
import { useCpfHash } from "./use-cpf-hash";

export interface AiAgentChatGaContext {
  page_path: string;
  userStatus: "authenticated" | "anonymous" | undefined;
  hashUserCpf: string | undefined;
}

export function useAiAgentChatGaContext(): AiAgentChatGaContext {
  const location = useLocation();
  const { keycloak, initialized } = useKeycloak<KeycloakInstance>();

  const hashUserCpf = useCpfHash(
    initialized ? keycloak?.token : undefined,
    keycloak?.authenticated
  );

  const userStatus = initialized
    ? keycloak?.authenticated
      ? "authenticated"
      : "anonymous"
    : undefined;

  return {
    page_path: location.pathname + location.search,
    userStatus,
    hashUserCpf,
  };
}
